<template>
  <div>
    <v-row>
      <v-col class="font-weight-bold">
        Groom Details
      </v-col>
    </v-row>
    <v-card class="px-3 pb-3" outlined>
      <v-row justify="center">
        <v-col cols="12" md="6" class="py-0">
          <v-text-field
            label="First Name"
            v-model="groom_details.first_name"
            :rules="rules.firstNameRule"
            hide-details="auto"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="py-0">
          <v-text-field
            label="Last Name"
            v-model="groom_details.last_name"
            hide-details="auto"
          >
          </v-text-field>
        </v-col>
      </v-row>

      <!-- %%%%%%%%%%%%%%%% IF PARENT SUPPORTED %%%%%%%%%%%%%%%% -->
      <v-row justify="center" v-if="template_details.parents_support">
        <v-col cols="12" md="6" class="py-0">
          <v-text-field
            label="Father's Name"
            v-model="groom_details.fathers_name"
            :rules="rules.fatherNameRule"
            hide-details="auto"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="py-0">
          <v-text-field
            label="Mother's Name"
            v-model="groom_details.mothers_name"
            :rules="rules.motherNameRule"
            hide-details="auto"
          >
          </v-text-field>
        </v-col>
      </v-row>
      <!-- %%%%%%%%%%%%%%%% IF GRAND PARENT SUPPORTED %%%%%%%%%%%%%%%% -->
      <v-row justify="center" v-if="template_details.grandparents_support">
        <v-col cols="12" md="6" class="py-0">
          <v-text-field
            label="Grand Father's Name(Optional)"
            v-model="groom_details.grand_fathers_name"
            hide-details="auto"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="py-0">
          <v-text-field
            label="Grand Mother's Name(Optional)"
            v-model="groom_details.grand_mothers_name"
            hide-details="auto"
          >
          </v-text-field>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>
<script>
import messages from "../../app-js/messages.js";
// import keys from "../../../app-js/keys.js";
// import urls from "../../app-js/urls.js";
export default {
  props: ["groom_details", "template_details"],
  data() {
    return {
      rules: {
        firstNameRule: [v => !!v || messages.GROOM_FIRST_NAME_ERROR],
        // lastNameRule: [v => !!v || messages.GROOM_FIRST_NAME_ERROR],
        fatherNameRule: [v => !!v || messages.GROOM_FATHER_NAME_ERROR],
        motherNameRule: [v => !!v || messages.GROOM_MOTHER_NAME_ERROR]
      }
    };
  },

  methods: {}
};
</script>
